import { inject } from '@angular/core';
import { Router, type CanMatchFn } from '@angular/router';

import { TokenStore } from '@core/services';

import { AuthStore } from '@core/auth';

export const authGuard: CanMatchFn = () => {
  const authStore = inject(AuthStore);
  const tokenStore = inject(TokenStore);
  const router = inject(Router);
  const status = authStore.status();
  if (status === 'authed') {
    return true;
  }
  if (tokenStore.hasAccessToken()) {
    authStore.setStatusAuthed();
    return true;
  }
  return router.createUrlTree(['/auth/login']);
};
